exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".green-key[data-v-06ee98b2] {\n  color: #3e7e26;\n}\n.green-key > div[data-v-06ee98b2]:hover {\n    cursor: pointer;\n    color: #5dbd3a;\n}\n.green-key .key[data-v-06ee98b2] {\n    font-size: 1rem;\n}\n.green-key .label[data-v-06ee98b2] {\n    font-weight: 600;\n}\n.green-key .text-label[data-v-06ee98b2] {\n    line-height: 10px;\n    position: absolute;\n    margin-top: -6px;\n    margin-left: 50px;\n    font-size: 0.835rem;\n    color: rgba(0, 0, 0, 0.5);\n    text-align: right;\n}\n", ""]);

// exports
